<template>
  <div class="update-fields">
    <div class="content-item">
      <div class="item-title">选择更新对象</div>
      <div class="title-tip">当前流程中的节点对象</div>
      <tree-select
        class="tree-select"
        :group-list="sheetList"
        v-model="updateData.sheetDataId"
        @change="getSheet"
      ></tree-select>
    </div>
    <div class="content-item">
      <div class="item-title">更新字段</div>
      <div v-if="updateData.sheetDataId">
        <div v-for="(item, index) in updateFields" :key="index" class="field-container">
          <div class="title-tip">将字段</div>
          <normal-select
            class="item-select"
            :select-list="controls"
            :selected-item.sync="item.key"
            @update:selectedItem="keyChange(item, $event)"
            size="normal"
            filterable
          ></normal-select>
          <condition-select
            v-model="item.type"
            :control="controlList[item.key]"
            @input="typeChange(item, $event)"
          ></condition-select>
          <control-value
            v-if="item.key && item.type != 'NULL'"
            v-model="extra.valueMap[item.key]"
            @input-val="item.value = $event"
            :control="controlList[item.key] || {}"
            :group-list="groupList"
          ></control-value>
          <el-input v-else disabled></el-input>
          <i class="el-icon-delete-solid icon-delField" @click="delUpdateFields(index)"></i>
          <div v-if="index < updateFields.length - 1" class="border-line"></div>
        </div>
        <div class="add-btn" @click="addUpdateFields">+ 添加字段</div>
      </div>
      <div v-else class="title-tip">必须先指定一个节点对象后，才能设置填写字段</div>
    </div>
    <div class="content-item">
      <div class="item-title">设置</div>
      <div class="setting">
        <el-checkbox v-model="updateData.canTrigger" style="margin-top: 5px">
          是否允许触发其他工作流
        </el-checkbox>
        <el-checkbox v-model="updateData.dealRef" style="margin-top: 10px">
          是否处理关联关系
        </el-checkbox>
      </div>
    </div>
  </div>
</template>

<script>
import NormalSelect from "@/components/UIComponents/NormalSelect"
import TreeSelect from "@/components/UIComponents/TreeSelect.vue"
import { getAvailableSheets, getSheetDefForEdit } from "@/api/sheet/sheet"
import { deepClone } from "@/utils/common"
import { disabledFieldTypes } from "@/utils/sheet"
import ControlValue from "@/components/Workflow/ControlValue"
import ConditionSelect from "@/components/UIComponents/ConditionSelect.vue"
import { transOldExpr } from "@/utils/workFlow"

export default {
  name: "update-fields",
  components: {
    NormalSelect,
    TreeSelect,
    ControlValue,
    ConditionSelect
  },
  inject: ["workflowType"],
  props: {
    groupList: Array,
    updateFields: Array,
    updateData: Object,
    extra: Object,
    sheetList: Array,
    controlTypeMap: Object
  },
  data() {
    return {
      isInitial: true,
      allSheet: [],
      controls: [],
      controlList: {},
      titleTip: {
        IS: "设为",
        ADD: "增加",
        DEL: "减少"
      }
    }
  },
  created() {
    getAvailableSheets({ appId: this.workflowType.id }).then(sheetDefs => {
      this.allSheet = sheetDefs.flatMap(app => app.sheets)
    })
  },
  methods: {
    initialData({ setEmpty } = { setEmpty: false }) {
      this.isInitial = true
      this.updateData.sheetDataId = transOldExpr(this.updateData.sheetDataId)
      if (this.updateData?.sheetId)
        this.getSheet({ control: { refSheetId: this.updateData.sheetId } })
      this.isInitial = false
    },
    verifyIsAllFill() {
      for (let item of this.updateFields) {
        if ((!item.key || !item.value) && item.type != "NULL") return false
      }
      return true
    },
    addUpdateFields() {
      if (!this.verifyIsAllFill()) {
        this.$notify({
          title: "提示",
          message: "请将已添加的项填写完后，再添加！",
          type: "warning"
        })
        return
      }
      let updateFields = deepClone(this.updateFields)
      updateFields.push({
        key: "",
        type: "IS",
        value: null
      })
      this.$emit("update:updateFields", updateFields)
    },
    delUpdateFields(index) {
      delete this.extra.valueMap[this.updateFields[index].key]
      this.updateFields.splice(index, 1)
    },
    getSheet(val) {
      this.controlList = {}
      if (!this.isInitial) {
        this.extra.valueMap = {}
        this.$emit("update:updateFields", [])
        Object.assign(this.extra, {
          updateField: val.label,
          sheetId: val.control.refSheetId,
          sheetName: this.allSheet.find(v => v.sheetId == val.control.refSheetId).name
        })
      }
      getSheetDefForEdit(val.control.refSheetId).then(res => {
        this.controls = res.controls
          .filter(control => !disabledFieldTypes.includes(control._type))
          .map(v => {
            this.controlList[v._cid] = v
            return { value: v._cid, label: `[${this.controlTypeMap[v._type]?.name}] ${v.name}` }
          })
      })
    },
    keyChange(item, val) {
      item.type = "IS"
    },
    typeChange(item, val) {
      if (val == "NULL") {
        item.value = null
        delete this.extra.valueMap[item.key]
      }
    }
  }
}
</script>

<style lang="scss">
.update-fields {
  .content-item {
    font-size: 13px;
    &:not(:first-child) {
      .item-title {
        margin-top: 18px;
      }
    }
    .item-title {
      font-weight: bold;
      .itemSubTitle {
        margin-left: 5px;
        font-size: 12px;
        cursor: pointer;
        color: #bdbdbd;
        &:hover {
          color: #1e88e5;
        }
      }
    }
    .title-tip {
      margin-top: 10px;
      color: #9e9e9e;
    }

    .tree-select {
      margin-top: 10px;
    }
    .item-select {
      margin-top: 10px;
    }

    .setting {
      display: flex;
      flex-flow: column;
    }
  }
  .field-container {
    padding-right: 25px;
    position: relative;
    &:hover {
      .icon-delField {
        display: block;
      }
    }
    .icon-delField {
      position: absolute;
      right: 5px;
      top: 40px;
      cursor: pointer;
      color: #bdbdbd;
      display: none;
      &:hover {
        color: #1e88e5;
      }
    }
  }
  .add-btn {
    display: inline-block;
    margin-top: 10px;
    height: 32px;
    line-height: 32px;
    border-width: 1px;
    border-style: solid;
    border-radius: 4px;
    padding: 0 20px;
    background: #f5f5f5;
    cursor: pointer;
    margin-right: 10px;
    box-sizing: border-box;
    color: #757575;
    border-color: #ddd;
    &:hover {
      border-color: #1e88e5;
    }
  }
  .border-line {
    height: 10px;
    border-bottom: 1px solid #e0e3e9;
  }
}
</style>
